// Settings Module - Main Coordinator
// Initializes and coordinates all settings functionality

import { initSystemPrompt, fetchSystemPrompt } from './settings/system-prompt.js';
import { initLLMProfiles, fetchProfiles, editProfile, activateProfile, deleteProfile } from './settings/llm-profiles.js';
import { initTTSProfiles, fetchTTSProfiles, editTTSProfile, activateTTSProfile, deleteTTSProfile } from './settings/tts-profiles.js';
import { renderLanguageOptions, switchLanguage } from './settings/language.js';
import { initBackgroundPicker, updateBackgroundTranslations } from './settings/background.js';


// Open settings modal
function openSettings() {
    const settingsModal = document.getElementById('settingsModal');
    const statusMessage = document.getElementById('statusMessage');

    if (settingsModal) {
        settingsModal.classList.add('show');
        fetchSystemPrompt();
        if (statusMessage) {
            statusMessage.className = 'status-message'; // Clear any previous status
        }
        initBackgroundPicker(); // Initialize background picker
    }
}

// Close settings modal
function closeSettings() {
    const settingsModal = document.getElementById('settingsModal');
    const statusMessage = document.getElementById('statusMessage');

    if (settingsModal) {
        settingsModal.classList.remove('show');
        if (statusMessage) {
            statusMessage.className = 'status-message'; // Clear status
        }
    }
}

// Initialize tab switching
function initTabSwitching() {
    const tabs = document.querySelectorAll('.settings-tab');
    const tabContents = document.querySelectorAll('.tab-content');

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const tabId = tab.dataset.tab;

            // Update tab buttons
            tabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');

            // Update tab contents
            tabContents.forEach(content => content.classList.remove('active'));
            const tabContent = document.getElementById('tab-' + tabId);
            if (tabContent) {
                tabContent.classList.add('active');
            }

            // Load profiles when switching to LLM Profiles tab
            if (tabId === 'llm-profiles') {
                fetchProfiles();
            } else if (tabId === 'tts-profiles') {
                fetchTTSProfiles();
            } else if (tabId === 'language') {
                renderLanguageOptions();
            } else if (tabId === 'ui-settings') {
                initBackgroundPicker(); // Refresh background picker
            }
        });
    });
}

// Initialize settings module
export function initSettings() {
    const settingsIcon = document.getElementById('settingsIcon');
    const closeModalBtn = document.getElementById('closeModal');
    const cancelBtn = document.getElementById('cancelBtn');
    const settingsModal = document.getElementById('settingsModal');

    // Modal open/close event listeners
    if (settingsIcon) {
        settingsIcon.addEventListener('click', openSettings);
    }
    if (closeModalBtn) {
        closeModalBtn.addEventListener('click', closeSettings);
    }
    if (cancelBtn) {
        cancelBtn.addEventListener('click', closeSettings);
    }

    // Close modal when clicking outside
    if (settingsModal) {
        settingsModal.addEventListener('click', (e) => {
            if (e.target === settingsModal) {
                closeSettings();
            }
        });
    }

    // Close modal with ESC key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && settingsModal && settingsModal.classList.contains('show')) {
            closeSettings();
        }
    });

    // Initialize all sub-modules
    initTabSwitching();
    initSystemPrompt();
    initLLMProfiles();
    initTTSProfiles();

    // Make functions globally available for onclick handlers in HTML
    window.editProfile = editProfile;
    window.activateProfile = activateProfile;
    window.deleteProfile = deleteProfile;
    window.editTTSProfile = editTTSProfile;
    window.activateTTSProfile = activateTTSProfile;
    window.deleteTTSProfile = deleteTTSProfile;
    window.switchLanguage = switchLanguage;
    window.fetchProfiles = fetchProfiles;
    window.fetchTTSProfiles = fetchTTSProfiles;

    console.log('Settings module initialized');
}

